"use client";

import RootStoreProvider from "./provider";

export { RootStoreProvider };
export { DataPromiseContext } from "./data-promise-context";
// Store accessors
export { useAuth } from "./hooks/use-auth";
export { useGlobal } from "./hooks/use-global";
// Lazy hydration hooks

/**
 * NOTE: we explicitly do NOT export useRoot. Do not add this, using useRoot directly is an antipattern
 */
export {
  useHydrateAutoPayEnrollments,
  useHydrateBanks,
  useHydrateContacts,
  useHydrateInvoices,
  useHydrateMeterReadings,
  useHydrateMeters,
  useHydrateNotifications,
  useHydratePaymentMethods,
  useHydratePayments,
  useHydrateServiceAccounts,
  useHydrateUser,
} from "./hooks/use-hydrate";
export { useOnboarding, useSetOnboarding } from "./hooks/use-onboarding";
export { useTenant } from "./hooks/use-tenant";
export { useTilliX } from "./hooks/use-tillix";
export type { DataPromiseMap } from "./data-promise-context";
